import { useState } from "react"
import MTable from "../../../../components/mtable"
import { formatEnum } from "../../../../utils/strings"
import CreateQuestion from "./CreateQuestion"
import { ConfirmButton } from "../../../../components/ConfirmButton"
import { QuestionSymmetry } from "../../../../utils/enums"

export default function Questions({questions, onAdd, onDelete}) {

    const [isCreate, setIsCreate] = useState(false)
    const [displayQuestion, setDisplayQuestion] = useState(undefined)

    const questionsMapper = {columns: [
        {
            label: "Question For Mentor",
            value: (item) => item?.questionSymmetry == QuestionSymmetry.MENTEE ? 'Only for Mentee' : item.textMentor?.length == 0 ? '--' : item.textMentor,
            width: "1.75fr",
            dynamicStyle: (item) => item?.questionSymmetry == QuestionSymmetry.MENTEE ? 'neutral medium' : ''
        },
        {
            label: "Question For Mentee",
            value: (item) => item?.questionSymmetry == QuestionSymmetry.MENTOR ? 'Only for Mentor' : item.textMentee?.length == 0 ? '--' : item.textMentee,
            style: "text-start",
            width: "1.75fr",
            dynamicStyle: (item) => item?.questionSymmetry == QuestionSymmetry.MENTOR ? 'neutral medium' : ''
        },
        {
            label: "Answer Type",
            value: (item) => formatEnum(item.answerType)
        },
        {
            label: "Answer Pool",
            value: (item) => formatEnum(item.answerType) == 'Text' ? '--' : (item?.selector ? formatEnum(item.selector) : `Custom Answers (${item.answersMentor?.length ?? 0})`)
        },
        {
            label: "Importance",
            value: (item) => `${(item.weight * 100).toFixed(0)}%`,
            width: '95px'
        }
    ]}

    const toggleAdd = () => {
        setDisplayQuestion(undefined)
        setIsCreate(!isCreate)
    }

    const handleOnAdd = (question) => {
        let idx = -1
        if (displayQuestion) idx = questions.indexOf(displayQuestion)
        onAdd(question, idx)
        setDisplayQuestion(undefined)
        setIsCreate(false)
    }

    const handleOnDelete = () => {
        let idx = -1
        if (displayQuestion) idx = questions.indexOf(displayQuestion)
        if (idx != -1) onDelete(idx)
        setDisplayQuestion(undefined)
        setIsCreate(false)
    }

    const onEdit = (question) => {
        setDisplayQuestion(question)
        setIsCreate(true)
    } 

    return(<>
        <div className="flex space-between gap-xs center v-spacer-xs">
            <p className="section-title-s">{isCreate ? 'Create Question' : 'Questions'}</p>
            <div className="flex gap-xs center">
                {displayQuestion && <ConfirmButton label={'Delete'} onClick={handleOnDelete}/>}
                <button className={`${isCreate ? 'outline' : 'solid'}`} onClick={toggleAdd}>{isCreate ? 'Cancel' : 'Create Question'}</button> 
            </div>
        </div>
        {!isCreate && <MTable rawData={questions} mapper={questionsMapper} onClick={onEdit}/>}
        {isCreate && <CreateQuestion onAdd={handleOnAdd} onDelete={handleOnDelete} question={displayQuestion}/>}
    </>)
}